<template>
	<div>
		<b-form v-if="editing !== null" id="form-content-form" @submit.prevent="handleSubmit">
			<b-card bg-variant="dark"
				header-text-variant="dark"
				body-border-variant="dark"
				no-body>
				<b-tabs card>
					<b-tab title="Conditions" active>
						<b-row>
							<b-col sm="3">
								<FormulateInput
									v-model="form.content[editing].step"
									type="number"
									name="step"
									label="Step"
									placeholder="1"
									validation="required"
									help="Current step the user is on" />
							</b-col>
							<b-col sm="5">
								<FormulateInput
									v-model="form.content[editing].substep"
									type="text"
									name="substep"
									label="Sub Step"
									placeholder="other"
									help="Can be left blank" />
							</b-col>
							<b-col sm="4">
								<FormulateInput
									v-model="form.content[editing].location"
									type="select"
									name="location"
									label="Location"
									:options="{before: 'Before Form Fields', after: 'After Form Fields'}"
									help="Select where to display this content; above or below the fields" />
							</b-col>
						</b-row>
					</b-tab>
					<b-tab title="Editor">
						<full-editor v-model="form.content[editing].content" :content="form.content[editing].content" />
						<p><small>Content will render differently on the web-form.</small></p>
					</b-tab>
				</b-tabs>
			</b-card>
			<div class="mt-3">
				<b-button
					variant="secondary"
					class="mr-2"
					@click="editing = null">
					Back
				</b-button>
				<b-button
					type="submit"
					variant="primary">
					Save Changes
				</b-button>
			</div>
		</b-form>
		<template v-if="length(form.content) && editing === null">
			<div class="mb-3">
				<b-row>
					<b-col sm="4" class="table-filters mb-3 mb-sm-0">
						<b-form-input v-model.trim="filter" placeholder="Search..."></b-form-input>
					</b-col>
					<b-col sm="8" class="text-sm-right">
						<b-button variant="primary" @click="addContent">Add Content</b-button>
					</b-col>
				</b-row>
			</div>
			<b-table
				ref="additionalInsuredTable"
				hover
				outlined
				dark
				:items="form.content"
				:fields="fields"
				:current-page="currentPage"
				:per-page="perPage"
				:filter="filter"
				:filter-included-fields="filterOn"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:sort-direction="sortDirection"
				responsive="md"
				stacked="sm">
				<template #cell(substep)="{ item }">
					<span v-if="item.substep">{{ item.substep }}</span>
					<span v-else>--</span>
				</template>
				<template #cell(actions)="data">
					<b-button variant="warning" size="sm" @click="editContent(data.item.index)">Edit</b-button>
					<b-button variant="danger" size="sm" @click="deleteContent(data.item.index)">Delete</b-button>
				</template>
			</b-table>
			<nav v-if="totalRows > perPage" class="pagination-nav">
				<b-pagination
					v-model="currentPage"
					:total-rows="totalRows"
					:per-page="perPage"></b-pagination>
			</nav>
		</template>
	</div>
</template>
<script>
import FormState from '@/Mixin/formstate'
import FullEditor from '@/Component/Tiptap/FullEditor'

export default {
	components: {
		FullEditor
	},
	mixins: [FormState],
	props: {
		formData: {
			type: Object,
			default: function () {
				return {
					'id': null
				}
			},
			required: false
		}
	},
	data () {
		return {
			form: this.$inertia.form({
				content: [
					{ step: null, substep: '', content: '' }
				]
			}),
			editing: null,
			fields: [
				{
					sortable: true,
					label: 'Step',
					key: 'step'
				},
				{
					sortable: true,
					label: 'Sub Step',
					key: 'substep'
				},
				{
					sortable: true,
					label: 'Location',
					key: 'location'
				},
				{
					sortable: false,
					label: '',
					key: 'actions',
					class: 'text-sm-right actions'
				}
			],
			totalRows: this.length(this.content),
			currentPage: 1,
			perPage: 15,
			pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: []
		}
	},
	created () {
		if (this.length(this.formData.content)) {
			this.form.content = this.formData.content
		}
	},
	methods: {
		addContent () {
			this.form.content.push({ step: null, substep: '', content: '' })
			this.editing = this.form.content.length - 1
		},
		editContent (index) {
			if (! index) {
				index = 0
			}

			this.editing = index
		},
		deleteContent (index) {
			if (! index) {
				index = 0
			}

			this.$bvModal.msgBoxConfirm('Are you sure?', {
				size: 'sm',
				buttonSize: 'sm',
				bodyBgVariant: 'dark',
				headerBgVariant: 'dark',
				footerBgVariant: 'dark',
				okVariant: 'danger',
				okTitle: 'Delete Forever',
				cancelTitle: 'Cancel',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					this.form.content.splice(index, 1)
					this.handleSubmit()
				}
			})

		},
		handleSubmit () {
			this.editing = null
			const updateRoute = this.route('admin.forms.update', this.formData.id)
			return this.form.put(updateRoute, {
				only: ['form', 'flash'],
				preserveScroll: true,
				preserveState: true
			})
		}
	}
}
</script>
